module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_heading-ashinagasan2501-sp-e7965df135d76063da6e127d590500a3.png";